/* InstallCount.styles.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _18 = "@keyframes k154l9z9{0%{background-color:var(--ds-skeleton,var(--ds-skeleton,rgba(9,30,66,.04)))}to{background-color:var(--ds-skeleton-subtle,rgba(9,30,66,.08))}}";
const _17 = "._7hjf1yy8{animation-direction:alternate}";
const _16 = "._1pglp3kn{animation-timing-function:linear}";
const _15 = "._tip812c5{animation-iteration-count:infinite}";
const _14 = "._5sag12o8{animation-duration:1.5s}";
const _13 = "._bfhk1mnh{background-color:var(--ds-skeleton,var(--ds-skeleton,rgba(9,30,66,.04)))}";
const _12 = "._j7hq19hg{animation-name:k154l9z9}";
const _11 = "._2rkoftgi{border-radius:8px}";
const _10 = "._4t3idlk8{height:14px}";
const _9 = "._1bsbcmky{width:88px}";
const _8 = "._19pkidpf{margin-top:0}";
const _7 = "._o5721q9c{white-space:nowrap}";
const _6 = "._12hn14w8 svg{transform:rotate(90deg)}";
const _5 = "._2hwx1b66{margin-right:var(--ds-space-050,4px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import SignInIcon from '@atlaskit/icon/glyph/sign-in';
import { skeletonShimmer } from '@atlaskit/theme';
import { N500 } from '@atlaskit/theme/colors';
import { BodyNormal } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._1n261q9c{flex-wrap:nowrap}";
const _3 = "._syazjjyb{color:var(--ds-text-subtle,#42526e)}";
const _2 = "._4cvr1h6o{align-items:center}";
const _ = "._1e0c116y{display:inline-flex}";
const shimmer = skeletonShimmer();
export const InstallCountWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c116y _4cvr1h6o _syazjjyb _1n261q9c", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InstallCountWrapper.displayName = 'InstallCountWrapper';
}
export const DownloadIconWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c116y _2hwx1b66 _12hn14w8", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DownloadIconWrapper.displayName = 'DownloadIconWrapper';
}
export const InstallCountTextV1 = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c116y _o5721q9c", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InstallCountTextV1.displayName = 'InstallCountTextV1';
}
export const InstallCountTextV2 = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c116y _o5721q9c _19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InstallCountTextV2.displayName = 'InstallCountTextV2';
}
export const DownloadIcon = props => {
  return /*#__PURE__*/_jsx(DownloadIconWrapper, {
    children: /*#__PURE__*/_jsx(SignInIcon, _objectSpread(_objectSpread({}, props), {}, {
      label: "Download Icon"
    }))
  });
};
export const InstallCountLoader = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11, _12, _13, _14, _15, _16, _17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsbcmky _4t3idlk8 _2rkoftgi _j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InstallCountLoader.displayName = 'InstallCountLoader';
}